/**
 * @title header.js: Sub-module of Browse feature
 * @description This module encapsulates all of the
 * functionality related to the header component.
 * @dependency utility.js
 */
define([], function() {
  var Footer = {
    /**
     * The initializing function modules use
     * to call.
     * @return {[type]} [description]
     */
    init: function() {
      COSTCO.util.safe(this.copyright)();
      COSTCO.util.safe(this.copy_content_to_accordion)();

      //ALM40905 Avoid calling these functions for CrossSiteRequestForgeryErrorView and ProhibitedCharacterErrorView 
      if(! $('#isErrorPage').val() || $('#isErrorPage').length == 0){
	      COSTCO.util.safe(this.country_select_addon)();
	      // STRY0170011 - Removed the Language Drop Down for BD if accessing from Mobile App
	      if (COSTCO.util.getLangId() != -1 && !(COSTCO.util.isRunningOnMobileApp() && COSTCO.util.isBusinessDelivery())) {
	        COSTCO.util.safe(this.language_region_select_addon)();
	      }
      }
      
      COSTCO.util.safe(this.loadImages)();
    },
    copyright: function() {
      $('#copyright-year').text(new Date().getFullYear());
    },
    /**
     * This copies the espot links from the footer into
     * their corresponding accordion panels. This eliminates
     * the need for the business to maintain duplicated content
     * @return {[type]}
     */
    copy_content_to_accordion: function() {
      if($(".footer-list").length === 5) {
        $('.footer-list').each(function(index, el) {
          $('#accordion-footer #collapse-' + (index + 1) + ' .panel-body').append(el.outerHTML);
        });
      } else {
        setTimeout(Footer.copy_content_to_accordion, 200);
      }
    },
    /**
     * Copies the country-select dropdown from the header to the footer
     * @return {[void]}
     */
    country_select_addon: function() {
      if ($('#country-select-popover-container').length > 0) {
      	let handler = 'id="footer-country-select"',
      		header = $('#country-select-popover-container').find('[data-selected=true] a').html(),
      		body = '<div class="footer-flags">' + $('#country-select-popover-container').html() + '</div>',
      		instructionText = $('.country-select-instruction').text();
        COSTCO.util.accordion_addon('accordion-footer', header, body, handler);
        //when clicking the accordion header, change the header text.
        $('#footer-country-select').find('.panel-heading').unbind('click').on('click', function() {
        	if ($(this).hasClass('collapsed')) {
        		$(this).find('a').text(instructionText);
        	}
        	else {
        		$(this).find('a').text(header);
        	}
        });
      }
    },
    /**
     * Copies the language/region-select dropdown from the header to the footer
     * @return {[void]}
     */
    language_region_select_addon: function() {
      var langSelect = $('#language-select');
      
      if(langSelect.length == 0){
    	  return true;
      }
      if (!COSTCO.util.isBusinessDelivery()){
    	  let handler = 'id="footer-language-select"',
    	 header = $('#header-selected-language').text(),
    	 body = '<div class="footer-language-flags">' + $('#language-select-popover-container').html() + '</div>';
    	  COSTCO.util.accordion_addon('accordion-footer', header, body, handler);
    	  $(".footer-language-flags").on('click','a', function(){
    	 		var selectedLangId = $(this).attr("langid");
    	 		COSTCO.util.addUrlToLangMap(window.location.pathname, selectedLangId);
    	 		COSTCO.myLocation.reloadWithNewLanguage(selectedLangId);
    	  });
      }else{
	      if ($('#region-select').length > 0) {
	        var header = $('#header-selected-language').text() + ' - ' + $.cookie('C_LOC').substring($.cookie('C_LOC').length - 2);
	      } else {
	        var header = $('#header-selected-language').text();
	      }
	      
	      var clickHandler = "onclick='if(event.stopPropagation){event.stopPropagation();event.preventDefault();}event.cancelBubble=true;COSTCO.Footer.language_region_handler();'";
	      COSTCO.util.accordion_addon('accordion-footer', header, null, clickHandler);
      }
    },
    /**
     * Handler function for the language/region-select accordion in the footer
     * @return {[void]}
     */
    language_region_handler: function() {
     if (COSTCO.util.isBusinessDelivery()){
      COSTCO.myLocation.initLocationModal(true);
      $('#costcoModal').one('hidden.bs.modal', function() {
        if ($('#region-select').length > 0) {
          var newHeader = $('#language-select').get(0).firstChild.nodeValue + ' - ' + $('#region-select').get(0).firstChild.nodeValue;
        } else {
          var newHeader = $('#language-select').get(0).firstChild.nodeValue;
        }
      $('.panel[onclick] .panel-title a').get(0).firstChild.nodeValue = newHeader;
      });
     }
    },
    /**
     * This function loads the image based on the device width.
     * Espot will be configured with the suitable data attributes,
     * and its values will be loaded based on the screen size.
     * @return {[void]}
     */
    loadImages: function() {
    	$(window).on("load resize", function(e){
		    var imageSource;
 		    $('.dynamic-image-load').each(function() {
 		    	var screenType = COSTCO.util.getScreenType();
 		    	var mobileDefaultLazyAttr = 'data-lazy-mobile';
 		    	if(screenType === 'PHONE-PORTRAIT') {
 		    		imageSource = $(this).is('[data-lazy-xs]')? $(this).attr('data-lazy-xs') : $(this).attr(mobileDefaultLazyAttr);
 		    	} else if(screenType === 'PHONE-LANDSCAPE') {
 		    		imageSource = $(this).is('[data-lazy-sm]') ? $(this).attr('data-lazy-sm') : $(this).attr(mobileDefaultLazyAttr);
 		    	} else if(screenType === 'TABLET-PORTRAIT'){
 		    		imageSource = $(this).is('[data-lazy-md]') ? $(this).attr('data-lazy-md') : $(this).attr(mobileDefaultLazyAttr);
 		    	} else if(screenType === 'TABLET-LANDSCAPE') {
 		    		imageSource = $(this).is('[data-lazy-lg]') ? $(this).attr('data-lazy-lg') : $(this).attr('data-lazy-desktop');
 		    	} else {
 		    		imageSource = $(this).attr('data-lazy-desktop');
 		    	}
 		    	//identified the screentype and setting the image source
 		    	$(this).attr('src', imageSource);
	        });
    	 });
    }
  }
  if (typeof window.COSTCO == 'undefined') {
    window.COSTCO = new Object();
  }
  window.COSTCO.Footer = Footer
  return Footer;
});



// WEBPACK FOOTER //
// ./js/browse/footer.js